import { templateApi } from '@/api/template';
import { defineStore } from 'pinia';

export const useTemplateStore = defineStore({
  id: 'templateStore',
  state: () => ({
    isCalled: false,
    image: [],
    word: [],
    upload: [],
    AIPrompt: [],
    // 템플릿 바로보기 팝업 (상품/단어설정/마진 템플릿을 어느 화면에서든 조회·수정)
    viewer: {
      open: false,
      type: '', // 'image' | 'word' | 'upload'
      templateId: '',
      templateName: ''
    }
  }),
  actions: {
    /**
     * 템플릿 바로보기 팝업 열기.
     * templateId 가 없으면 templateName 으로 스토어에서 찾아본다.
     */
    openTemplateViewer({ type, templateId, templateName }) {
      if (!type) return;
      let id = templateId === undefined || templateId === null ? '' : String(templateId);
      const name = templateName ?? '';
      if (!id && name) {
        const found = (this[type] ?? []).find(template => template.templateName === name);
        if (found) id = String(found.templateId);
      }
      this.viewer = { open: true, type, templateId: id, templateName: name };
    },
    closeTemplateViewer() {
      this.viewer = { open: false, type: '', templateId: '', templateName: '' };
    },
    async setTemplateList() {
      this.isCalled = true;
      let promises = [
        templateApi.GetImageConfig(),
        templateApi.GetWordTemplateNameList(),
        templateApi.GetUploadConfig(),
        templateApi.GetAIPromptTemplateNameList()
      ];

      try {
        let promiseResult = await Promise.all(promises);
        for (let template of promiseResult[0].data) {
          this.image.push({
            templateId: String(template.idx),
            templateName: template.templateName
          });
        }
        for (let template of promiseResult[1].data) {
          this.word.push({
            templateId: template.guid,
            templateName: template.templateName
          });
        }
        for (let template of promiseResult[2].data) {
          this.upload.push({
            templateId: String(template.idx),
            templateName: template.templateName
          });
        }
        for (let template of promiseResult[3].data) {
          this.AIPrompt.push({
            templateId: template.guid,
            templateName: template.templateName
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    async setImageTemplate() {
      this.image = [];
      const res = await templateApi.GetImageConfig();
      for (let template of res.data) {
        this.image.push({
          templateId: String(template.idx),
          templateName: template.templateName
        });
      }
    },
    async setUploadTemplate() {
      this.upload = [];
      const res = await templateApi.GetUploadConfig();
      for (let template of res.data) {
        this.upload.push({
          templateId: String(template.idx),
          templateName: template.templateName
        });
      }
    },
    async setWordTemplate() {
      this.word = [];
      const res = await templateApi.GetWordTemplateNameList();
      for (let template of res.data) {
        this.word.push({
          templateId: template.guid,
          templateName: template.templateName
        });
      }
    },
    async setAIPromptTemplate() {
      this.AIPrompt = [];
      const res = await templateApi.GetAIPromptTemplateNameList();
      for (let template of res.data) {
        this.AIPrompt.push({
          templateId: template.guid,
          templateName: template.templateName
        });
      }
    },
    clearTemplate() {
      this.word = [];
      this.upload = [];
      this.image = [];
      this.AIPrompt = [];
      this.isCalled = false;
    }
  }
});
